import { Button } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog, Markdown, Stack, useText } from "@sveabank/cc-common";
import Card from "../../../../components/card";

type Props = {
	setOpen: (isOpen: boolean) => void;
	isOpen: boolean;
};

const BoInfoModal = ({ setOpen, isOpen }: Props) => {
	const [t, texts] = useText();

	return (
		<Dialog
			isOpen={isOpen}
			setOpen={setOpen}
			size="auto"
			center={false}
			heading={t(texts.kyc.beneficialOwnership.infoHeading)}
		>
			<Dialog.Content>
				<Stack gap={4}>
					<Card classNames="bg-background-tertiary" boxShadow={false} direction="col" fullWidth>
						<Stack>
							<Markdown allowParagraphs>{t(texts.kyc.beneficialOwnership.infoText1)}</Markdown>
						</Stack>
					</Card>
					<Stack>
						<Markdown allowParagraphs>{t(texts.kyc.beneficialOwnership.infoText2)}</Markdown>
					</Stack>
				</Stack>
			</Dialog.Content>
			<ButtonGroup>
				<Button variant="primary" width="full" onPress={() => setOpen(false)}>
					{t(texts.error.modal.close)}
				</Button>
			</ButtonGroup>
		</Dialog>
	);
};

export default BoInfoModal;
